import ReactDOM from 'react-dom';
import { App } from './App';
import { EverestProvider } from '@ceridianhcm/components';
import "@ceridianhcm/components/dist/index.css";
import "@ceridianhcm/theme/dist/theme.css"; // fonts and global typography styles
const dotenv = require("dotenv");
dotenv.config({ path: `./.env` });

const rootNode = document.getElementById('root');
if (rootNode) {
  ReactDOM.render(
    <EverestProvider id="client-profile-center-container">
      <div id="client-profile-center" data-testid="client-profile-center">
          <App />
      </div>
    </EverestProvider>,
    rootNode,
  );
}
